export enum BadgeBasis {
  TOTAL_TRIPS = 'TOTAL_TRIPS',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
}
